module.exports = __webpack_public_path__ + "img/dy-qrcode.3104edd9.jpg";